<template>
  <div class="Society">
    <ModuleTitle :ModuleTitle="Module_title"></ModuleTitle>
    <div class="Society_box">
      <div class="Society_box_content">
        <div class="Society_img_box">
          <img src="../../../assets/image/Index/Society1.jpg" alt />

          <div class="title">
            <p>全球塑料展望呼吁更多的循 环…</p>
          </div>
        </div>
        <div class="Society_text">
          <div class="Society_text_content">
            根据经济合作与发展组织 (OECD) 2 ⽉发布的
            《全球塑料展望：经济驱动因素、环境影响和
            政策选择》，⼈们对塑料污染的认识不断提⾼
            影响了公众舆论并导致了更强有⼒的…
          </div>
          <div class="more">查看更多></div>
        </div>
      </div>

      <div class="Society_box_content">
        <div class="Society_img_box">
          <img src="../../../assets/image/Index/Society2.jpg" alt />

          <div class="title">
            <p>巴塞罗那加强“影响伙伴关 系”</p>
          </div>
        </div>
        <div class="Society_text">
          <div class="Society_text_content">
            根据经济合作与发展组织 (OECD) 2 ⽉发布的
            《全球塑料展望：经济驱动因素、环境影响和
            政策选择》，⼈们对塑料污染的认识不断提⾼
            影响了公众舆论并导致了更强有⼒的…
          </div>
          <div class="more">查看更多></div>
        </div>
      </div>
      <div class="Society_box_content">
        <div class="Society_img_box">
          <img src="../../../assets/image/Index/Society1.jpg" alt />

          <div class="title">
            <p>全球塑料展望呼吁更多的循 塑料展望呼吁更多的循 环…</p>
          </div>
        </div>
        <div class="Society_text">
          <div class="Society_text_content">
            根据经济合作与发展组织 (OECD) 2 ⽉发布的
            《全球塑料展望：经济驱动因素、环境影响和
            政策选择》，⼈们对塑料污染的认识不断提⾼
            影响了公众舆论并导致了更强有⼒的…
          </div>
          <div class="more">查看更多></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Module_title: {name:"Society",more:true}
    };
  },
  components: {
    ModuleTitle: () =>
      import("../../PublicComponents/ModuleTitle/ModuleTitle.vue")
  }
};
</script>

<style lang="scss" scoped>
.Society {
  width: 1200px;
  margin: auto;
  .Society_title {
    display: inline-block;
    margin: 40px 0 30px;
    color: #fff;
    padding: 10px 30px;
    background: #439f38;
  }
}
.Society_box {
  display: flex;
  flex-direction: row;
  // height: 600px;
  .Society_box_content:last-child {
    margin-right: 0px;
  }
  .Society_box_content:first-child {
    margin-left: 0px;
  }
  .Society_box_content {
    cursor: pointer;
    margin: 0 10px;
    // background: #ccc;
    width: 100%;
    height: 100%;
    &:hover .Society_text {
      background: #00689d;

      color: #fff;
      transition: 0.8s ease;
    }
    &:hover img {
      transition: 0.8s ease;
      transform: scale(1.2, 1.2);
    }
    &:hover .Society_text .more {
      color: #fff;
      transition: 0.8s ease;
    }
    .Society_img_box {
      position: relative;
      width: 386px;
      height: 486px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;

        transition: 0.8s ease;
      }

      .title {
        // width: 100%;
        padding: 20px;
        // height: 80px;
        position: absolute;
        bottom: 0;
        color: #fff;
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 15px;
      }
    }
    .Society_text {
      width: 100%;
      height: 204px;
      // border-bottom-left-radius: 4px;
      // border-bottom-right-radius: 4px;
      border-radius: 4px;
      color: #333333;

      .Society_text_content {
        word-wrap: break-word;
        word-break: normal;
        letter-spacing: 0px;
        padding: 20px;
        line-height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }
      .more {
        padding-left: 20px;
        // width: 80px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #006eff;
        line-height: 22px;
      }
    }
  }
}
</style>
